
<template>
  <div class="record_box"
       style="height:100%;">
    <div ref="mescroll"
         class="mescroll noticeBox">
      <div>
        <div class="header">
          <p class="balance">账户余额</p>
          <p class="bal_money">{{money}} <span class="dw">元</span></p>
        </div>
        <div class="record_item"
             id="noticeList">
          <div class="item"
               v-for="(item,idx) in balanceList"
               :key="idx">
            <div class="info">
              <p class="title">{{item.type==1?'拒就赔劵兑换':'提现'}}</p>
              <p class="time">{{item.gmtCreated}}</p>
            </div>
            <div class="money">
              <p><span :class="{'add red':item.type==1,'reduce gray':item.type==2}">{{item.type==1?'+':'-'}}</span><span :class="{'red':item.type==1,'gray':item.type==2}">{{item.money}}</span> <span :class="{'redDw':item.type==1,'grayDw':item.type==2}">元</span></p>
            </div>
          </div>
          <!-- <div class="item">
          <div class="info">
            <p class="title">拒就赔劵兑换</p>
            <p class="time">2019-09-02 12:34:53</p>
          </div>
          <div class="money">
            <p><span class="reduce gray">-</span><span class="gray">100</span> <span class="grayDw">元</span></p>
          </div>
        </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import MeScroll from 'mescroll.js'
import 'mescroll.js/mescroll.min.css'
export default {
  components: {
    MeScroll
  },
  data () {
    return {
      money: '',
      balanceList: [],
      page: 1,
      pageSize: 10,
      mescroll: null, //mescroll实例对象
    }
  },
  mounted () {
    this.util.title('余额记录');
    let _this = this;
    // this.getBalanceList();
    _this.mescroll = new MeScroll(_this.$refs.mescroll, { //请至少在vue的mounted生命周期初始化mescroll,以确保您配置的id能够被找到
      up: {
        auto: true,
        callback: _this.getBalanceList, //上拉回调
        page: {
          size: 10
        },
        clearEmptyId: 'noticeList',
        offset: 10,
        noMoreSize: 3,
        htmlNodata: '<p class="upwarp-nodata">-- End --</p>'
      },
      down: {
        auto: false,//自动加载
        isBounce: false,
        callback: _this.downCallback
      }
    });
  },
  methods: {
    /**
            * 下拉刷新
            */
    downCallback () {
      //下拉刷新的回调
      this.getBalanceList(1, false);
    },
    getBalanceList (page, isLoadMore) {
      let _this = this;
      let param = {
        pageNum: page.num,
        pageSize: this.pageSize,
      }
      if (!isLoadMore) {//下拉
        param.pageNum = 1
      }
      this.$get('/app/v1.0/memeber/getAccountPrepaid', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.money = e.data.money;
            // _this.balanceList = e.data.data;
            if (isLoadMore) {
              //产品分页
              let productList = e.data.data;
              _this.mescroll.endBySize(productList.length, e.data.total);
              _this.balanceList = _this.balanceList.concat(productList);
              if ((page.num - 1) == 0 && !(productList.length > 0)) {
                // _this.showEmpty = true;
              } else {
                // _this.showEmpty = false;
              }
            } else {
              _this.balanceList = e.data.data
              _this.mescroll.endSuccess();
            }
          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { console.log('错误') });
    }

  }

}
</script>
<style scoped>
/* 非vip样式 */
.mescroll {
    position: fixed;
    padding-bottom: 1rem;
    top: 2px;
    bottom: 0;
    height: auto;
  -webkit-overflow-scrolling: touch;
}
.record_box {
  font-family: PingFangSC-Regular;
  background: #fff;
  padding: 0.15rem;
}
.bank_icon1 {
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url('../../assets/img/vip/add_bank.png') no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-left: 0.15rem;
  border-radius: 50%;
  position: relative;
  top: 0.02rem;
}
.header {
  width: 100%;
  height: 1.06rem;
  background: linear-gradient(
    135deg,
    rgba(255, 172, 85, 1) 0%,
    rgba(255, 57, 31, 1) 100%
  );
  box-shadow: 0px 4px 10px 0px rgba(255, 191, 128, 0.2);
  border-radius: 4px;
  margin: 0 auto;
  padding: 0.24rem 0.15rem 0.22rem 0.15rem;
  margin-bottom: 0.08rem;
}
.bal_money {
  font-family: DINAlternate-Bold;
  font-size: 0.4rem;
  color: #fff;
  position: relative;
  top: -0.06rem;
}
.balance {
  color: #fff;
  font-size: 0.12rem;
}
.dw {
  font-size: 0.14rem;
  top: -0.03rem;
  font-size: 0.14rem;
  position: relative;
  left: -0.06rem;
}
.item {
  display: flex;
  flex: 1;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 0.12rem;
  font-size: 0.14rem;
  padding-top: 0.12rem;
}
.item .title {
  color: #333;
}
.item .time {
  color: #999;
}
.item .gray {
  color: #666;
  font-size: 0.26rem;
}
.item .red {
  color: #ff514a;
  font-size: 0.26rem;
}
.redDw {
  color: #ff514a;
  font-size: 0.14rem;
}
.grayDw {
  color: #666;
  font-size: 0.14rem;
}
</style>
